module.exports = __webpack_public_path__ + "19dae0c725f3f430b6e7f2c101f18bbe.jpg";